import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "";

const isNgrok = API_BASE_URL.includes("ngrok");

export const AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "/",
    ...(isNgrok && { "ngrok-skip-browser-warning": "true" }),
  },
  timeout: 100000,
});

// Decide which token to use based on current path
const getToken = (): string | null => {
  const pathname = window.location.pathname;
  if (pathname.startsWith("/admin")) {
    return localStorage.getItem("token_admin");
  } else {
    return localStorage.getItem("token_user");
  }
};

// Attach token to every request
AxiosInstance.interceptors.request.use(
  (config) => {
    if (config.headers?.skipAuth || config.headers?.["skipAuth"]) {
      delete config.headers.skipAuth;
      delete config.headers["skipAuth"];
      return config;
    }
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);



